import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../firebase';
import { SavedTour, TourResponse } from '../types/tour';

const savedToursCollection = (userId: string) =>
  collection(db, 'users', userId, 'savedTours');

function sanitizeTourForFirestore(tour: TourResponse) {
  return {
    tourTitle: tour.tourTitle,
    duration: tour.duration,
    tourDetails: tour.tourDetails.map((detail) => ({
      pointOfInterest: detail.pointOfInterest,
      location: detail.location,
      ...(detail.locationDetails ? { locationDetails: detail.locationDetails } : {}),
      description: detail.description,
      timeSpent: detail.timeSpent,
      walkingDirections: detail.walkingDirections,
      funFacts: detail.funFacts,
      coordinates: detail.coordinates ?? null,
      ...(detail.thumbnailUrl ? { thumbnailUrl: detail.thumbnailUrl } : {}),
    })),
  };
}

export async function saveTourForUser(
  userId: string,
  tour: TourResponse,
  meta: { city?: string; theme?: string }
): Promise<string> {
  const docRef = await addDoc(savedToursCollection(userId), {
    ...sanitizeTourForFirestore(tour),
    city: meta.city || null,
    theme: meta.theme || null,
    savedAt: serverTimestamp(),
  });

  return docRef.id;
}

export async function getSavedToursForUser(userId: string): Promise<SavedTour[]> {
  const snapshot = await getDocs(
    query(savedToursCollection(userId), orderBy('savedAt', 'desc'))
  );

  return snapshot.docs.map((savedDoc) => {
    const data = savedDoc.data();
    const savedAt = data.savedAt instanceof Timestamp ? data.savedAt.toDate() : null;

    return {
      id: savedDoc.id,
      tourTitle: data.tourTitle,
      duration: data.duration,
      tourDetails: data.tourDetails,
      city: data.city ?? null,
      theme: data.theme ?? null,
      savedAt,
    };
  });
}

export async function deleteSavedTour(userId: string, tourId: string): Promise<void> {
  await deleteDoc(doc(db, 'users', userId, 'savedTours', tourId));
}
